export enum ANALYTICS_PAGE_ZONE {
  CARE_TILE = 'Care Tile',
}

export enum ANALYTICS_CTA_VALUE {
  EXPERT_SERVICES_DESIGN_SERVICES_BRIEF = 'expertServices-Design Services:Printed Product Brief-hireAFreelancer',
}

export const URL_TARGET = '/design/get-started'

export const AVAILABLE_LOCALE_FOR_PRICE = 'en-us'

export const CARE_TILE_PRICING_TEXT = {
  CTA_TEXT: 'Custom design from $10',
  CAPTION_TEXT: 'Get a professional design from scratch.',
  HEADING_TEXT: 'Work with a designer',
}

export const DESIGNERS_IMAGE = 'https://cms.cloudinary.vpsvc.com/image/upload/f_auto,q_auto/Gallery/assets/care-tile-designers.png'
